import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { findSelectedList, getIsAuthenticated, getLists } from '../selectors';

// getSelectedList as a hook: the scan reruns only when your lists change,
// not on every dispatch.
export default function useSelectedList(bookId, workId) {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const items = useSelector(getLists);
  return useMemo(
    () => (isAuthenticated ? findSelectedList(items, bookId, workId) : null),
    [isAuthenticated, items, bookId, workId]
  );
}
